import { render, staticRenderFns } from "./OrderPath.vue?vue&type=template&id=1618f4e4&scoped=true"
import script from "./OrderPath.vue?vue&type=script&lang=js"
export * from "./OrderPath.vue?vue&type=script&lang=js"
import style0 from "./OrderPath.vue?vue&type=style&index=0&id=1618f4e4&prod&lang=scss&scoped=true"
import style1 from "./OrderPath.vue?vue&type=style&index=1&id=1618f4e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1618f4e4",
  null
  
)

/* custom blocks */
import block0 from "./OrderPath.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports